import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function Category() {
  return (
    <>
      <Navbar />
      <main className="min-h-screen pt-20 px-4 md:px-6">
        <div className="mx-auto max-w-[1400px] py-10">
          <h1 className="text-2xl font-heading text-foreground-800">漫画分类</h1>
          <p className="text-foreground-500 mt-2">分类页面开发中...</p>
        </div>
      </main>
      <Footer />
    </>
  );
}